module.exports = __webpack_public_path__ + "img/qidian.4d0ce955.svg";